import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { levelLabel } from "@/lib/levels";
import { Check } from "lucide-react";

const KIND_LABEL = { session: "8-Week Session", class: "Single Class", workshop: "Workshop" };

// Shared class/shop catalog grid — used by the public Shop page and the in-portal Shop tab.
export default function ProductGrid({ compact = false }) {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/products").then(({ data }) => setProducts(data)).catch(() => {});
  }, []);

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 ${compact ? "" : "lg:grid-cols-3"} gap-6`} data-testid="product-grid">
      {products.map((p) => (
        <div key={p.id} className="flex flex-col bg-white rounded-3xl border border-[#dfd8da] overflow-hidden shadow-sm" data-testid={`product-${p.lookup_key}`}>
          <div className="bg-[#550001] text-white p-6">
            <div className="text-xs uppercase tracking-[0.22em] font-extrabold text-[#bf6163]">{KIND_LABEL[p.kind] || p.kind}</div>
            <h2 className="mt-2 text-2xl font-bold">{p.name}</h2>
            <div className="mt-3 font-display text-4xl">{p.price_display}</div>
          </div>
          <div className="flex-1 p-6">
            <p className="text-[#545454]">{p.blurb}</p>
            <ul className="mt-4 space-y-2 text-sm text-[#1a1617]">
              <li className="flex items-center gap-2"><Check size={16} className="text-[#920e12]" /> {levelLabel(p.level)} curriculum</li>
              <li className="flex items-center gap-2"><Check size={16} className="text-[#920e12]" /> Ways to play without speaking included</li>
              <li className="flex items-center gap-2"><Check size={16} className="text-[#920e12]" /> Capacity {p.capacity} · waitlist if full</li>
            </ul>
          </div>
          <div className="p-6 pt-0">
            <Button
              onClick={() => navigate(`/enroll/${p.lookup_key}`)}
              className="w-full h-11 bg-[#920e12] hover:bg-[#550001] text-white font-bold"
              data-testid={`enroll-${p.lookup_key}`}
            >
              Enroll &amp; consent
            </Button>
          </div>
        </div>
      ))}
      {products.length === 0 && <p className="text-[#545454]">No classes available right now.</p>}
    </div>
  );
}
